module.exports = __webpack_public_path__ + "img/angus_niu1.5b0aef39.png";